import { FOCUS_VISIBLE_RING_CLASS } from 'newApp/constants/accessibility';

export const REGULAR_MEMBER_TYPE = 0;

export const UPGRADE_MEMBERSHIP_ACTION = 'upgradeMembership';

export const SAVED_PROFILE_COOKIE = 'saveUserProfileData' as const;

export const MY_OPENSOOQ_ENDPOINTS = {
  accountFeatures: '/account/my-account-features',
  accountOverview: '/account/my-account/overview/v1',
  accountStats: 'member-stats/leads?types=views,posts,cvs&group=weekly&range=30',
  buyerSummary: '/account/demand/buyer-summary',
  sellerSummary: '/account/listings/my-listings-by-status',
  shopLimit: 'account/limits/shop',
};

export const SHARE_ENDPOINTS = {
  logShare: 'logging/share',
  shortUrl: 'sites/shorten',
};

export const SHARE_CAMPAIGN = 'account_share_from_myaccount';

export const VIEW_ACCOUNT_CAMPAIGN = 'view_account_from_myopensooq';

export const CARD_CLASS = 'tw-rounded-lg tw-bg-white tw-shadow-[0_0_20px_0_rgba(76,87,125,0.02)]';

export const CARD_HEADER_CLASS =
  'tw-flex tw-min-h-[70px] tw-flex-col tw-justify-center tw-px-4 tw-py-2 tw-mb-2';

export const CARD_TITLE_CLASS = 'tw-m-0 tw-text-lg tw-font-semibold tw-text-[#181c32]';

export const CARD_DESCRIPTION_CLASS = 'tw-m-0 tw-mt-1 tw-text-xs tw-font-medium tw-text-[#4e4e61]';

export const CARD_BODY_CLASS = 'tw-flex tw-flex-1 tw-flex-col tw-px-4 md:tw-px-4 tw-pb-8';

export const ROW_CLASS = `tw-block tw-w-full tw-rounded-md tw-border tw-border-dashed tw-border-[#e4e6ef] tw-p-2 tw-text-start hover:tw-bg-[#f2f2f7] ${FOCUS_VISIBLE_RING_CLASS} hover:tw-text-[#0368ff]`;

export const ROW_LABEL_CLASS = 'tw-text-sm tw-font-semibold';

export const BADGE_CLASS =
  'tw-inline-flex tw-shrink-0 tw-items-center tw-rounded-md tw-px-2 tw-py-1 tw-text-xs tw-font-semibold';

export const BADGE_LIGHT_CLASS = `${BADGE_CLASS} tw-bg-[#f5f8fa] tw-text-black`;

export const SKELETON_CLASS = 'tw-inline-block tw-animate-pulse tw-rounded tw-bg-[#ebebeb]';

export const PRIMARY_BUTTON_CLASS = `tw-inline-flex tw-items-center tw-justify-center tw-rounded-md tw-bg-[#0368ff] tw-px-6 tw-py-2.5 tw-text-sm tw-font-medium tw-text-white hover:tw-bg-[#0356d6] hover:tw-text-white ${FOCUS_VISIBLE_RING_CLASS}`;

export const LIGHT_BUTTON_CLASS = `tw-inline-flex tw-min-h-11 tw-items-center tw-justify-center tw-gap-2 tw-rounded-md tw-bg-[#f5f8fa] tw-px-4 tw-py-2 tw-text-xs tw-font-semibold tw-text-black hover:tw-bg-[#eff2f5] hover:tw-text-black ${FOCUS_VISIBLE_RING_CLASS}`;

export const LINK_BUTTON_CLASS = `tw-inline-flex tw-min-h-11 tw-items-center tw-rounded-sm tw-text-xs tw-font-medium tw-text-[#0368ff] tw-gap-1 ${FOCUS_VISIBLE_RING_CLASS}`;

export const TONE_BULLET_CLASSES = {
  danger: 'tw-bg-[#c20326]',
  neutral: 'tw-bg-[#e4e6ef]',
  primary: 'tw-bg-[#0368ff]',
  success: 'tw-bg-[#098502]',
  warning: 'tw-bg-[#fe9d01]',
};

export const TONE_BADGE_CLASSES = {
  danger: 'tw-bg-[#fff5f8]',
  neutral: 'tw-bg-[#f5f8fa]',
  primary: 'tw-bg-[#f1faff]',
  success: 'tw-bg-[#e8fff3]',
  warning: 'tw-bg-[#fff8dd]',
};

export const BUYER_ICON_SPRITES = {
  favorites: 'ReferralFavoritesIcon',
  following: 'ReferralFollowingIcon',
  jobs: 'ReferralJobsIcon',
  'recently-viewed': 'ReferralRecentlyViewedIcon',
  search: 'ReferralSearchIcon',
};
